import { useEffect, useRef, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { MOBILE } from '@thd-olt-functional/utils';

/*
    useTippyToggle hooks gets the state of a input (radio/checkbox) and
    return a ref that can be passed into the tooltip associated with it.

    useTippyToggle implicitly takes care of toggling the tippy tooltip using ref value.

    useTippyToggle is specific to product add ons use business use case and
    works with only tippy tooltip, so currently this cannot be exported out.
*/

export const useTippyToggle = (inputState) => {
  const tooltipButtonRef = useRef(null);
  const { channel } = useContext(ExperienceContext);

  useEffect(() => {
    if (
      channel !== MOBILE
      && tooltipButtonRef?.current
      && (inputState !== Boolean(tooltipButtonRef?.current?._tippy?.state?.isVisible))) {
      tooltipButtonRef.current.click();
    }
  }, [inputState]);

  return tooltipButtonRef;
};
